import { nanoid } from "nanoid";
import { useEffect, useState } from "react";

interface LoadJSONHookOptions {
  url: string | null;
}

// export const useLoadJson = ({url}:LoadJSONHookOptions) => {

export const useLoadJson = <T extends Object> ( {url}:LoadJSONHookOptions, initState: T ) => {

    const [data, setData] = useState<T>(initState)
    const [isPending, setIsPending] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect( () => {

        const getData = async(url: string) => {

            const id = nanoid()
            
            try{
                let res = await fetch(url)
                if(!res.ok){
                    throw{
                        err:true,
                        status:res.status,
                        statusText: !res.statusText?"Ocurrio Error": res.statusText
                    }
                }
                let data = await res.json()
                
                setIsPending(false)
                setData(data)
                setError(null)
                
            }catch(err){
                console.log(err)
                setIsPending(true)
            }
        }

        if(url){
            getData(url)
        }
    }, [url] )


    return {data, isPending, error}
}
